import React from 'react'
import { PAYMENT, ARTIST_PAYOUT } from '../../helpers/constants'
import type { SectionProps } from './Section'
import Section from './Section'

const Component = (props: SectionProps): React.ReactElement<React.ComponentProps<any>, any> => {
  const { currentSection, onToggle, section } = props
  return (
    <Section
      name={PAYMENT}
      title='How do I get paid?'
      {...{
        currentSection,
        onToggle,
        section,
      }}
    >
      <p>
        The funds will be made available in your Sales Dashboard 14-19 days after successful
        delivery. You can be paid by check, wire transfer, or PayPal. All you have to do is log into
        your Saatchi Art account, and go to your Sales Dashboard in order to request your payout.{' '}
        <a data-type='link' target='_blank' rel='noopener noreferrer' href={ARTIST_PAYOUT}>
          Learn More
        </a>
      </p>
    </Section>
  )
}

export default Component